import { ICarePlansStore } from './types';

const initStore: ICarePlansStore = {
  item: null,
};

export default initStore;
